<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
    <cf-info-banner
      v-if="isClaimPointBannerDisplayed"
      :message="giftedPointsInfoBannerContent"
      icon="cf-icon far fa-gift"
    />

    <img
      v-if="dynamicContent.CreateAccount.metadata.imageUrl"
      class="cf-image cf-image--center cf-image--logo"
      :alt="merchant.name"
      :src="dynamicContent.CreateAccount.metadata.imageUrl"
      onerror="this.src='/images/image-not-found.png';"
    >

    <h1
      v-if="dynamicContent.CreateAccount.title"
      class="cf-title cf-title--1"
    >
      {{ dynamicContent.CreateAccount.title }}
    </h1>

    <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">
      {{ dynamicContent.CreateAccount.metadata.subtitle }}
    </p>

    <div
      v-if="dynamicContent.CreateAccount.metadata.attributes.length > 0"
      class="create-account-attribute-group"
    >
      <div
        v-for="attribute in dynamicContent.CreateAccount.metadata.attributes"
        :key="attribute.attributeText"
        class="cf-flex cf-flex--column cf-flex--align-center"
      >
        <img
          v-if="attribute.iconUrl"
          class="cf-image cf-image--icon half-spacing"
          :alt="attribute.attributeText"
          :src="attribute.iconUrl"
        >

        <h3 class="cf-title cf-title--5">{{ attribute.attributeText }}</h3>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfInfoBanner from '@/view/components/shared/cf-info-banner/index.vue';


  export default {
    name: 'SignUpHeader',

    components: {
      CfInfoBanner
    },

    computed: {
      ...mapGetters('content', ['dynamicContent']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['loyalty', 'offers']),

      isClaimPointBannerDisplayed() {
        return !!this.offers.giftingPoints.pointGiftClaimCode;
      },

      giftedPointsInfoBannerContent() {
        const pointsCurrency = this.offers.giftingPoints.currencyPluralName;

        return `Create an account to claim your ${pointsCurrency}!`;
      }
    }

  };
</script>


<style lang="sass">

.create-account-attribute-group
  display: grid
  grid-auto-flow: column
  grid-auto-columns: 1fr
  gap: 1rem

</style>
